var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPainel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#ACACAB",
    strokeWidth: 2,
    d: "M14.351 2.13l10.016 8.536c.84.717.942 1.979.225 2.82-.38.445-.936.702-1.522.702h-1.237v9.55c0 1.105-.895 2-2 2h-3.468v-6.955c0-.513-.386-.935-.884-.993l-.116-.007h-4.563c-.513 0-.935.386-.993.883l-.007.117v6.956H6.333c-1.104 0-2-.896-2-2v-9.55h-.662c-1.105 0-2-.896-2-2 0-.564.237-1.101.654-1.48l9.383-8.536c.745-.678 1.877-.696 2.643-.043z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPainel);
export default __webpack_public_path__ + "static/media/icon_painel.34978bf1303fbb91e776d5239c18cd62.svg";
export { ForwardRef as ReactComponent };